var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialogVisible)?_c('div',{staticClass:"fund-list",staticStyle:{"right":"20%"}},[_c('InvestCasesList',{attrs:{"name":_vm.name,"rid":_vm.rid,"cases":_vm.investmentCase},on:{"mark":_vm.handleMark,"quit":_vm.handleQuit,"change":_vm.handleChange,"close":_vm.handleClose}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }